import React from "react";
import { useTranslation } from "react-i18next";

const SelectJurisdiction = (props) => {

    const { jurisdiction, setJurisdiction, includeGlobal, barebones } = props;

    const { t } = useTranslation();

    const jurisdictions = [
        {country: "Belgium", flag: "🇧🇪"},
        {country: "Netherlands", flag: "🇳🇱"},
        {country: "France", flag: "🇫🇷"},
        {country: "UK", flag: "🇬🇧"},
        {country: "USA", flag: "🇺🇸"},
        {country: "Germany", flag: "🇩🇪"},
        {country: "Switzerland", flag: "🇨🇭"},
        {country: "Luxemburg", flag: "🇱🇺"},
        {country: "Canada", flag: "🇨🇦"},
      ];

      if(includeGlobal) {
        jurisdictions.unshift({country: "Global", flag: "🌍"});
      }
  
      const options = jurisdictions.map((jurisdiction, index) => {
        return (
          <option 
            key={index} 
            value={jurisdiction.country}
          >
            {jurisdiction.flag}&nbsp;&nbsp;{t(jurisdiction.country)}
          </option>
        )
      });

      if(barebones) return (
        <div className=" select selectJurisdiction barebones">
          <div className="selectHolder">
            <span className="selection">{jurisdictions.find((jur) => jur.country === jurisdiction)?.flag}&nbsp;&nbsp;{t(jurisdiction)}</span>
            <select onChange={(e) => setJurisdiction(e.target.value)} defaultValue={jurisdiction}>
              {options}
            </select>
          </div>
        </div>
      );
  
      return (
        <div className=" select selectJurisdiction">
          <h3>{t('analysis.settings_6')}</h3>
          <div className="selectHolder">
            <span className="selection">{jurisdictions.find((jur) => jur.country === jurisdiction)?.flag}&nbsp;&nbsp;{t(jurisdiction)}</span>
            <select onChange={(e) => setJurisdiction(e.target.value)} defaultValue={jurisdiction}>
              {options}
            </select>
          </div>
        </div>
      );
};

export default SelectJurisdiction;